import React from 'react';
import { SearchAddressContext } from './SearchAddressContext.ts';

export const useSearchAddress = () => {
  return React.useContext(SearchAddressContext);
};
